module.exports = __webpack_public_path__ + "img/ANDREIA.3bcb5ef4.jpeg";